import React from 'react'
import { IDiscountCode, updateDiscountCodes } from '../../store/paymentData'
import { Button, Col, ListGroup, Row } from 'react-bootstrap'
import { useAppDispatch } from '../../hooks'

const DiscountCodeItem = (props: {
    discountCode: IDiscountCode
}) => {
    const { discountCode } = props
    const dispatch = useAppDispatch()
    return (
        <ListGroup.Item>
            <Row>
                <Col xs={8} className="d-flex alert-success justify-content-center align-items-center border border-success rounded text-dark">
                    {discountCode.code} {discountCode.code !== discountCode.used_code ? `(${discountCode.used_code})` : ''} - {discountCode.discount}%
                </Col>
                <Col xs={4}>
                    <Button size={"sm"} variant='danger' onClick={() => {
                        dispatch(updateDiscountCodes({discountCode: discountCode, action: 'remove'}))
                    }}>X</Button>
                </Col>
            </Row>
        </ListGroup.Item>
    )
}

export default DiscountCodeItem
